export const SENIOR_PRE_REVIEW_PRESCREEN_STATUS = "SENIOR_PRE_REVIEW";

export const LOAN_PRESCREEN_TEXT = `Thank you for the submission.<br><br>

I have reviewed the loan, see my comments below:<br><br>

<li>Loan Terms</li>
<li>Borrower</li>
<li>Collateral</li>
<li>Exit Strategy</li>
<br><br>
Note:
Please note this is not an agreement to fund a loan. Loan terms and structure are subject to change in underwriting or with committee. This is not a term sheet. We are providing feedback based on the information you have submitted and is subject to change.<br>
`;

export const LOAN_PRESCREEN_EXCEPTION_TEXT = `-<br><br>
Note: Please note final terms will be decided at time of underwriting and credit approval.
`;